import { Close } from "@faire/slate-icons/Close";
import React from "react";

export const TagDismissIcon: React.FC = () => (
  <div className="fs-tag__dismiss-btn-icon">
    <Close color="inherit" titleAccess="" />
  </div>
);
